import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileTypeEnum } from '@models/media-library.model.ts';
import MediaLibraryComponent from '@components/media-library-component/media-library-component.tsx';
import { Button } from '@mui/material';
import documentFileImage from '@assets/icons/file-document.svg';
import useLiveTvStore from '@modules/entertainment/pages/live-tv/store/live-tv.store.ts';
import { getDownloadFileUrl } from '@api/file-upload-api.ts';
import { TableState } from '@store/table-store/table.model.ts';

const M3e8DialogContent: React.FC<{
  onClose: () => void;
  state: TableState;
}> = ({ onClose, state }) => {
  const { t } = useTranslation();
  const { importM3u, isLoading } = useLiveTvStore();
  const [selectedMedia, setSelectedMedia] = React.useState<Record<string, any>>(
    {}
  );
  const [isGettingUrl, setIsGettingUrl] = React.useState(false);

  const handleSave = async () => {
    if (!selectedMedia.m3e8) return;

    try {
      setIsGettingUrl(true);
      const filePath = selectedMedia.m3e8.path;

      const { url } = await getDownloadFileUrl(filePath);

      importM3u({
        data: { playlistUrl: url },
        handleClose: onClose,
        state
      });
    } catch (err) {
      void err;
    } finally {
      setIsGettingUrl(false);
    }
  };

  return (
    <div className="w-full flex flex-col justify-center items-center gap-10">
      <p className="max-w-[60%] ml-auto mr-auto text-center text-base font-medium text-[rgba(25,27,27,0.8)] opacity-50 max-lg-xl:max-w-[80%]">
        {t('entertainment_live_tv_import_m3e8_channels_desc')}
      </p>

      <MediaLibraryComponent
        mediaKey="m3e8"
        allowedTypes={[FileTypeEnum.All]}
        title={t('entertainment_live_tv_import_m3e8_title')}
        icon={<img src={documentFileImage} alt="Document Image" />}
        onSelect={(media) => setSelectedMedia({ m3e8: media })}
      />

      <Button
        onClick={handleSave}
        loading={isGettingUrl || isLoading()}
        disabled={!selectedMedia.m3e8 || isGettingUrl || isLoading()}
        variant="contained"
      >
        {t('import')}
      </Button>
    </div>
  );
};

export default M3e8DialogContent;
